import { useAtomValue } from 'jotai';
import { Tabs } from '@antimatterhq/ui/components/tabs';
import { QueryTabList } from './_partials/QueryTabList';
import { QueryTabContent } from './_partials/QueryTabContent';
import { QueryEmptyState } from './_partials/QueryEmptyState';
import {
  hasOpenQueryTabsAtom,
  queryTabsInitializationStateAtom,
} from '@/atoms/query/queryAtoms';
import { useQueryTabs } from '@/hooks/query/useQueryTabs';

export default function QueryPage() {
  const hasOpenTabs = useAtomValue(hasOpenQueryTabsAtom);
  const queryTabsInitializationState = useAtomValue(
    queryTabsInitializationStateAtom,
  );

  useQueryTabs();

  // This should be a loading state, but we don't have one yet.
  if (queryTabsInitializationState !== 'initialized') {
    return null;
  }

  if (!hasOpenTabs) {
    return (
      <div className="flex h-full flex-col" data-testid="query-page">
        <QueryEmptyState />
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col" data-testid="query-page">
      <Tabs.Root className="flex h-full flex-col">
        <QueryTabList />
        <QueryTabContent />
      </Tabs.Root>
    </div>
  );
}
